import { gql } from '@grandvisionhq/graphql';

const deliveryEstimationResponse = gql`
  fragment DeliveryEstimationResponseFragment on DeliveryEstimationResponse {
    response {
      ... on DeliveryDateEstimation {
        deliveryDate
        shippingDate
        shippingMethodDescription {
          locale
          value
          __typename
        }
        __typename
      }
      ... on DeliveryRangeEstimation {
        deliveryRanges {
          min
          max
          minWithPrescription
          maxWithPrescription
        }
        shippingMethodDescription {
          locale
          value
          __typename
        }
        __typename
      }
    }
    failures {
      ... on GenericEstimationFailure {
        message
      }
    }
  }
`;

export { deliveryEstimationResponse };
//# sourceMappingURL=delivery-estimation.js.map
